import { StatsDataService } from '../../../service/stats-data/service';
import { StatsEmitterEntityStrategy } from './entity-strategy';

export function StatsEmitterEntityStrategyFactory(): StatsEmitterEntityStrategy {
  return new StatsEmitterEntityStrategy(StatsDataService());
}
